import {
  IconArrowsMaximize,
  IconArrowsMove,
  IconMinimize,
  IconRotateClockwise2,
  IconWashDryShade
} from '@tabler/icons-react';
import {
  TransitionLifeCycleType,
  TransitionMoveDirection,
  TransitionRotateDirection,
  TransitionType
} from './Transitions.types';

export const TransitionConfig = {
  [TransitionType.FADE]: {
    label: 'Fade',
    Icon: IconWashDryShade
  },
  [TransitionType.DROP]: {
    label: 'Drop',
    dropDelta: 0.3,
    Icon: IconMinimize
  },
  [TransitionType.MOVE]: {
    label: 'Move',
    moveDelta: 0.1, // % of width/height of canvas
    Icon: IconArrowsMove
  },
  [TransitionType.ROTATE]: {
    label: 'Rotate',
    rotateDelta: 20, // degrees
    Icon: IconRotateClockwise2
  },
  [TransitionType.SCALE]: {
    label: 'Scale',
    scaleDelta: 0.3,
    Icon: IconArrowsMaximize
  }
};

export const TRANSITION_MINIMUM_DURATION = 100;
export const TRANSITION_MAXIMUM_DURATION = 2000;

export const TransformConfig = {
  [TransitionType.FADE]: {
    [TransitionLifeCycleType.IN]: {
      opacity: [0, 1]
    },
    [TransitionLifeCycleType.OUT]: {
      opacity: [1, 0]
    }
  },
  [TransitionType.DROP]: {
    [TransitionLifeCycleType.IN]: {
      scale: [1 + TransitionConfig[TransitionType.DROP].dropDelta, 1]
    },
    [TransitionLifeCycleType.OUT]: {
      scale: [1, 1 + TransitionConfig[TransitionType.DROP].dropDelta]
    }
  },
  [TransitionType.ROTATE]: {
    [TransitionLifeCycleType.IN]: {
      [TransitionRotateDirection.CLOCKWISE]: {
        rotate: [-TransitionConfig[TransitionType.ROTATE].rotateDelta, 0]
      },
      [TransitionRotateDirection.ANTI_CLOCKWISE]: {
        rotate: [TransitionConfig[TransitionType.ROTATE].rotateDelta, 0]
      }
    },
    [TransitionLifeCycleType.OUT]: {
      [TransitionRotateDirection.CLOCKWISE]: {
        rotate: [0, TransitionConfig[TransitionType.ROTATE].rotateDelta]
      },
      [TransitionRotateDirection.ANTI_CLOCKWISE]: {
        rotate: [0, -TransitionConfig[TransitionType.ROTATE].rotateDelta]
      }
    }
  },
  [TransitionType.SCALE]: {
    [TransitionLifeCycleType.IN]: {
      scale: [1 - TransitionConfig[TransitionType.SCALE].scaleDelta, 1]
    },
    [TransitionLifeCycleType.OUT]: {
      scale: [1, 1 - TransitionConfig[TransitionType.SCALE].scaleDelta]
    }
  },
  [TransitionType.MOVE]: {
    [TransitionLifeCycleType.IN]: {
      [TransitionMoveDirection.UP]: {
        translateY: [TransitionConfig[TransitionType.MOVE].moveDelta, 0],
        translateX: [0, 0]
      },
      [TransitionMoveDirection.DOWN]: {
        translateY: [-TransitionConfig[TransitionType.MOVE].moveDelta, 0],
        translateX: [0, 0]
      },
      [TransitionMoveDirection.LEFT]: {
        translateX: [TransitionConfig[TransitionType.MOVE].moveDelta, 0],
        translateY: [0, 0]
      },
      [TransitionMoveDirection.RIGHT]: {
        translateX: [-TransitionConfig[TransitionType.MOVE].moveDelta, 0],
        translateY: [0, 0]
      }
    },
    [TransitionLifeCycleType.OUT]: {
      [TransitionMoveDirection.UP]: {
        translateY: [0, -TransitionConfig[TransitionType.MOVE].moveDelta],
        translateX: [0, 0]
      },
      [TransitionMoveDirection.DOWN]: {
        translateY: [0, TransitionConfig[TransitionType.MOVE].moveDelta],
        translateX: [0, 0]
      },
      [TransitionMoveDirection.LEFT]: {
        translateX: [0, -TransitionConfig[TransitionType.MOVE].moveDelta],
        translateY: [0, 0]
      },
      [TransitionMoveDirection.RIGHT]: {
        translateX: [0, TransitionConfig[TransitionType.MOVE].moveDelta],
        translateY: [0, 0]
      }
    }
  }
} as const;
